"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRawGtx = isRawGtx;
const buffer_1 = require("buffer");
const zod_1 = require("zod");
const bufferSchema = zod_1.z.custom(val => buffer_1.Buffer.isBuffer(val), {
    message: "Expected Buffer",
});
const rawGtvSchema = zod_1.z.lazy(() => zod_1.z.union([
    zod_1.z.null(),
    zod_1.z.boolean(),
    bufferSchema,
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.bigint(),
    zod_1.z.array(rawGtvSchema),
    zod_1.z.record(rawGtvSchema),
]));
const rawGtxOpSchema = zod_1.z.tuple([zod_1.z.string(), zod_1.z.array(rawGtvSchema)]);
const rawGtxBodySchema = zod_1.z.tuple([bufferSchema, zod_1.z.array(rawGtxOpSchema), zod_1.z.array(bufferSchema)]);
const rawGtxSchema = zod_1.z.tuple([rawGtxBodySchema, zod_1.z.array(bufferSchema)]);
function isRawGtx(value) {
    const result = rawGtxSchema.safeParse(value);
    return result.success;
}
//# sourceMappingURL=rawGtx.js.map